module.exports = __webpack_public_path__ + "static/media/Dominica.9c835dd8.png";